import React from 'react'

import { Flex, Image, Box, Text, Button } from '@chatterbug/aaron'
import { Modal } from '@chatterbug/aaron/modal'
import { t } from 'src/lib/i18n-react'

import { customModalStyle } from '../utils'
import sadComputer from './assets/sadComputer.svg'

type Props = {
  isOpen: boolean
  onHide: () => void
}

const UpdateBrowserModal: React.FC<Props> = ({ isOpen, onHide }) => {
  const linkAttributes =
    'target="_blank" rel="noopener" style="color: black; text-decoration: underline;"'
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onHide}
      style={customModalStyle}
      shouldCloseOnOverlayClick={false}
    >
      <Flex
        flexDirection="column"
        width={{ _: 'auto', laptop: '598px' }}
        alignItems="center"
        textAlign="center"
      >
        <Image src={sadComputer} width="168" alt="" />
        <Text fontWeight="bold" fontSize={{ _: 'md', tablet: 'lg' }} my="3x">
          {t('It breaks our heart, but this browser isn’t supported.')}
        </Text>
        <Box
          mb="5x"
          dangerouslySetInnerHTML={{
            __html: t(
              'For a smooth experience please download the latest version of <a href="https://www.google.com/chrome/" %{linkAttributes}>Google Chrome</a> or <a href="https://www.mozilla.org/en-US/firefox/new/" %{linkAttributes}>Mozilla Firefox</a>.',
              {
                linkAttributes,
              }
            ),
          }}
        />

        <Box mb="3x">
          <Button
            data-testid="dismiss-browser-update-modal-button"
            type="primaryAdvanced"
            onClick={onHide}
          >
            {t('Got it')}
          </Button>
        </Box>
      </Flex>
    </Modal>
  )
}

export default UpdateBrowserModal
